
import { EntBreedingFarm } from "../../../models/breedingFarm";
import { EntBreedingFarmFilter } from "../../../models/filters/breedingFarmFilter";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
export const breedingFarmApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({


    getBreedingFarmList: builder.query<ResponseDataGet<EntBreedingFarm>, EntBreedingFarmFilter>({
      
      query: (filter) => ({
        url: "/breeding-farm/get-all",
        method: "POST",
        body: JSON.stringify(filter)
        
        
      }),
    }),
    getBreedingFarmById: builder.query<ResponseDataTest<EntBreedingFarm>, number>({
      query: (id) => ({
        url: `/breeding-farm/${id}`,
        method: 'GET'
      })
    }),
    addBreedingFarm: builder.mutation<ResponseDataTest<EntBreedingFarm>, EntBreedingFarm>({
      query: (body) => ({
        url: `/breeding-farm`,
        method: "POST",
        body: JSON.stringify(body)
      }),
      onQueryStarted: async (user, { dispatch, queryFulfilled }) => {
        try {
        } catch { }
      }
    }),
    editBreedingFarm: builder.mutation<ResponseDataTest<EntBreedingFarm>, EntBreedingFarm>({
      query: (body,) => ({
        url: `/breeding-farm`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
      onQueryStarted: async (user, { dispatch, queryFulfilled }) => { }
    }),
    deleteBreedingFarm: builder.mutation<ResponseDataTest<EntBreedingFarm>, number>({
      query: (id) => ({
        url: `/breeding-farm/${id}`,
        method: 'DELETE',
      }),
      onQueryStarted: async (id, { dispatch, queryFulfilled }) => { }
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddBreedingFarmMutation,
  useDeleteBreedingFarmMutation,
  useEditBreedingFarmMutation,
  useGetBreedingFarmByIdQuery,
  useGetBreedingFarmListQuery,
  useLazyGetBreedingFarmListQuery
} = breedingFarmApi;
